import { config } from "@/src/config";
import * as Device from "expo-device";
import { Platform } from "react-native";
import { getAbortControllerTimeout } from "./getAbortControllerTimeout";

async function getScanRes(res: Response) {
  const success = res.status === 200;
  return res.json().then((k) => {
    if (success) {
      return {
        success: true,
        poll_interval: k.poll_interval,
        poll_token: k.poll_token,
      };
    }
  });
}
export async function getPollingTokenForDeviceCode(
  deviceCode: string,
  deviceId?: string | null
) {
  const name_suggestion =
    Platform.OS === "ios"
      ? Device.modelName
      : (Device.deviceName ?? Device.modelName);
  const abortController = getAbortControllerTimeout(10000);
  const _res = await fetch(
    `${config.baseUrl}/shared_group_device/qr-login/scan`,
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      signal: abortController?.signal,
      body: JSON.stringify({
        grant_type: "group_device_scan",
        device_code: deviceCode,
        name_suggestion: name_suggestion,
        device_id: deviceId,
      }),
    }
  );

  const res = await getScanRes(_res);
  if (res?.success) {
    return {
      poll_token: res.poll_token,
      poll_interval: res.poll_interval,
    };
  }
  throw new Error("Error when trying to login");
}
